module.exports = __webpack_public_path__ + "img/icon.a1955e7c.png";